import { create } from "zustand"

// Draft key for a proposal that creates an article; existing articles key on their id.
export function createDraftKey(proposalId: string): string {
	return `new:${proposalId}`
}

interface ReviewDraft {
	html?: string
	title?: string
}

interface ReviewDraftStore {
	drafts: Record<string, ReviewDraft>
	setDraft: (key: string, draft: ReviewDraft) => void
	clearDraft: (key: string) => void
}

export const useReviewDraftStore = create<ReviewDraftStore>()((set) => ({
	drafts: {},
	setDraft: (key, draft) =>
		set((state) => ({
			drafts: { ...state.drafts, [key]: { ...state.drafts[key], ...draft } },
		})),
	clearDraft: (key) =>
		set((state) => {
			const { [key]: _removed, ...rest } = state.drafts
			return { drafts: rest }
		}),
}))
